<template>
	<div>
		<FormDialog :formObject="formObject" :formInfo="formInfo"></FormDialog>
		<div class="flex">
			<div class="flex_item">
				<el-input style="width: 200px;" v-model="name" placeholder="输入姓名搜索"></el-input>
				<el-button type="primary" @click="search">搜索</el-button>
			</div>
			<div class="flex_item">
				<el-button type="primary" @click="add">新增</el-button>
				<el-button type="success" @click="edit">编辑</el-button>
				<el-button type="danger" @click="delete_all">删除</el-button>
			</div>
		</div>
		<TableList :tableHeader="tableHeader" :tableData="tableData" @selectTableRows="selectTableRows"></TableList>
		<PageNation :pageTotle="page_totle" @currentPage='currentPage'></PageNation>
		<UploadFile downloadUrl="/admin/teacher/excel_export" uploadUrl="/admin/teacher/insert_excel"></UploadFile>
		<div class="row">
			<el-button  size="small" type="primary" @click="download"
				style="width: 200px;">下载数据
			</el-button>
		</div>
	</div>
</template>

<script>
	import UploadFile from '../../components/UploadFile.vue'
	import PageNation from '../../components/PageNation.vue'
	import TableList from '../../components/TableList.vue'
	import FormDialog from '../../components/FormDialog.vue'
	import {
		getData,
		del
	} from "@/utils/table"
	export default {
		name: 'DtTeacher',
		components: {
			UploadFile,
			PageNation,
			TableList,
			FormDialog
		},
		data() {
			return {
				formObject: {},
				formInfo: {},
				tableHeader: [{
						fixed: true,
						prop: 'id',
						label: '教师编号',
						width: 200
					},
					{
						fixed: false,
						prop: 'class_name',
						label: '班级',
						width: 150
					},
					{
						fixed: false,
						prop: 'teacher',
						label: '姓名',
						width: 200
					},
					{
						fixed: false,
						prop: 'market',
						label: '情况',
						width: null
					}
				],
				tableData: [],
				name: "",
				searchData: false,
				page_totle: 1,
				ids: [],
				tableRows: []
			}
		},
		created() {
			getData(this, "/admin/education/index", {
				page: 1
			}, data => {
				this.page_totle = data[0]
				this.tableData = data[1]
			})
			getData(this, "/admin/teacher/school", {
				page: 1
			}, data => {
				this.school=data
			})
		},
		methods: {
			//搜索数据
			search() {
				if (this.name === "") {
					this.$message({
						message: '请输入姓名',
						type: 'warning'
					})
				} else {
					this.searchData = true
					getData(this, '/admin/teacher/search', {
						name: this.name,
						page: 1
					}, data => {
						this.page_totle = data[0]
						this.tableData = data[1]
					})
				}
			},
			//添加数据
			add() {
				this.formInfo = {
					title: '增加教师',
					visible: true,
					url: '/admin/teacher/add',
					formItems: [{
							label: "教师姓名",
							key: "name",
							type: "input"
						},
						{
							label: "电话",
							key: "tele",
							type: 'input'
						},
						{
							label: "分校",
							key: "campus_id",
							type: 'radio',
							options: this.school.campus
						}
					],
					rules: {
						name: [{
								required: true,
								message: '姓名必填',
								trigger: 'blur'
							},
						],
						tele: [{
								required: true,
								message: '电话必填',
								trigger: 'blur'
							},
						],
						campus_name: [{
								required: true,
								message: '分校必选',
								trigger: 'blur'
							},
						],
					}
				}
			},
			//编辑数据
			edit() {
				if (this.tableRows.length < 1) {
					this.$message({
						message: '请选择一条数据！',
						type: 'warning'
					})
				} else {
					if (this.tableRows.length == 1) {
						this.formObject = {
							...this.tableRows[0]
						}
						this.formInfo.title = '编辑教师信息'
						this.formInfo.visible = true
						this.formInfo.url = '/admin/teacher/edit'
					} else {
						this.$message({
							message: '只能选择一条数据！',
							type: 'warning'
						})
					}
				}
			},
			//删除数据
			delete_all() {
				if (this.tableRows.length == 0) {
					this.$message({
						message: '选择数据',
						type: 'warning'
					})
				} else {
					let arr = []
					let ids = []
					for (var i = 0; i < this.tableRows.length; i++) {
						arr.push(this.tableRows[i].name)
						ids.push(this.tableRows[i].id)
					}
					del(this, "/admin/teacher/delete", arr.toString(), {
						ids: ids.join(",")
					}, () => {
						for (var k = 0; k < ids.length; k++) {
							for (var i = 0; i < this.tableData.length; i++) {
								if (this.tableData[i].id == ids[k]) {
									this.tableData.splice(i, 1);
								}
							}
						}
					})
				}
			},
			download(){
				this.formInfo = {
					title: '选择时间',
					type:'download',
					visible: true,
					url: '/admin/education/excel_export',
					formItems: [{
							label: "开始时间",
							key: "start_time",
							type: "date"
						},
						{
							label: "截止时间",
							key: "end_time",
							type: 'date'
						}
					],
					rules: {
						start_time: [{
								required: true,
								message: '开始时间必填',
								trigger: 'blur'
							},
						],
						end_time: [{
								required: true,
								message: '截止时间必填',
								trigger: 'blur'
							},
						]
					}
				}
			},
			//表格选择处理，选出每条数据的编码
			selectTableRows(tableRows) {
				this.tableRows = tableRows;
			},
			//翻页处理
			currentPage(val) {
				if (this.searchData) {
					getData(this, '/admin/teacher/search', {
						name: this.name,
						page: 1
					}, data => {
						this.page_totle = data[0]
						this.tableData = data[1]
					})
				} else {
					getData(this, "/admin/teacher/index", {
						page: val
					}, data => {
						this.page_totle = data[0]
						this.tableData = data[1]
					})
				}

			}
		}
	}
</script>
<style lang="scss">
	.flex {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-top: 10px;
	}
</style>